import * as Yup from 'yup'

import flow from 'lodash/flow'

import date from '@galo-monitor/forms/validators/date.validator'
import float from '@galo-monitor/forms/validators/float.validator'
import required from '@galo-monitor/forms/validators/required.validator'

const harvestSchema = ({ t }) => Yup.object().shape({
  plots: Yup.array().of(Yup.object().shape({
    id: required({ t, isNotText: true })(Yup.boolean())
  })),
  date_initial: flow(
    date({ t }),
    required({ t })
  )(Yup.string()),
  date_finish: flow(
    date({ t }),
    required({ t })
  )(Yup.string()),
  area_total: flow(
    float({ t }),
    required({ t })
  )(Yup.string()),
  production_total_gross: required({ t })(Yup.string()),
  machines: Yup.array().of(Yup.object().shape({
    machine_id: required({ t })(Yup.string())
  })),
  user_responsible_id: required({ t })(Yup.string())
})

export default harvestSchema
